export const filterPopup = {
  updated() {
    const event = new Event('dynamic_top:mobile', { bubbles: true });
    const target = document.getElementsByClassName('filter-popup-wrapper')[0];
    target.dispatchEvent(event);
  }
};
